import { render, staticRenderFns } from "./RideTable.component.vue?vue&type=template&id=0dbdde8f"
import script from "./RideTable.component.vue?vue&type=script&lang=ts"
export * from "./RideTable.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports